import React, { useState } from "react";
import Button from "@mui/joy/Button";
import Modal from "@mui/joy/Modal";
import ModalClose from "@mui/joy/ModalClose";
import Typography from "@mui/joy/Typography";
import Sheet from "@mui/joy/Sheet";
import AddPlusButton from "../../../../components/admin/usable/AddPlusButton";
import BangladeshFlag from "../../../../assets/icons/bangladesh.svg";
import AddButton from "../../../../components/admin/usable/AddButton";
import CancelButton from "../../../../components/admin/usable/CancelButton";

const AddCustomers = ({ setFormData, FormData, handleSubmit }) => {
  const [open, setOpen] = useState(false);

  const handleCancel = () => {
    setFormData({
      fullName: "",
      email: "",
      phoneNumber: "",
      password: "123456",
      isCustomer: 1,
      isWelcomed: 1,
      status: 1,
      createdAt: new Date().toISOString(),
    });
    setOpen(false);
  };
  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };
  return (
    <>
      <AddPlusButton onClick={() => setOpen(true)} />
      <Modal
        aria-labelledby="modal-title"
        aria-describedby="modal-desc"
        open={open}
        onClose={() => setOpen(false)}
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <Sheet
          variant="outlined"
          sx={{ maxWidth: 500, borderRadius: "md", p: 3, boxShadow: "lg" }}
        >
          <ModalClose variant="plain" sx={{ m: 1 }} />
          <Typography
            component="h2"
            id="modal-title"
            level="h4"
            textColor="inherit"
            sx={{ fontWeight: "lg", mb: 1 }}
          >
            Add Customer
          </Typography>
          <div className="space-y-3">
            <div className="w-full px-0 space-y-5">
              <div>
                <label htmlFor="password" className="text-black/60 text-xs">
                  Full Name <small>(Legal Name)</small>
                </label>
                <input
                  type="text"
                  placeholder="Enter your full name"
                  className="border w-full px-2 py-3 rounded-md focus:outline-none"
                  value={FormData.fullName}
                  onChange={handleChange}
                  id="fullName"
                />
              </div>
              <div className="relative">
                <label htmlFor="phoneNumber" className="text-black/60 text-xs">
                  Phone Number
                </label>
                <input
                  type="text"
                  placeholder="Enter Phone Number"
                  className="border w-full px-12 py-3 rounded-md focus:outline-none"
                  value={FormData.phoneNumber}
                  onChange={handleChange}
                  id="phoneNumber"
                />
                <div className="absolute top-9 left-2 w-7 h-7 overflow-hidden rounded-lg bg-white">
                  <img
                    className="w-full h-full object-cover"
                    src={BangladeshFlag}
                    alt=""
                  />
                </div>
              </div>
              <div>
                <label htmlFor="password" className="text-black/60 text-xs">
                  Email
                </label>
                <input
                  type="text"
                  placeholder="Enter your email address"
                  className="border w-full px-2 py-3 rounded-md focus:outline-none"
                  value={FormData.email}
                  onChange={handleChange}
                  id="email"
                />
              </div>
              <div>
                <label htmlFor="password" className="text-black/60 text-xs">
                  Password
                </label>
                <input
                  type="text"
                  placeholder="Enter your password"
                  className="border w-full px-2 py-3 rounded-md focus:outline-none"
                  value={FormData.password}
                  onChange={handleChange}
                  id="password"
                />
              </div>
            </div>
            <div className="flex justify-end items-center gap-2">
              <AddButton onClick={() => handleSubmit()} text={"Add Now"} />
              <CancelButton onClick={handleCancel} text={"Cancel"} />
            </div>
          </div>
        </Sheet>
      </Modal>
    </>
  );
};

export default AddCustomers;
